.HomeContent {
  background-color: var(--overlay);
  height: 100%;
  border-radius: 30px;
  overflow-y: auto;
  padding: 24px;
  position: relative;
}

.ScrapingModal {
  position: absolute;
  top: var(--topbar-desktop-height);
  background: rgba(0, 0, 0, 0.45);
  width: 100%;
  height: calc(100% - var(--topbar-desktop-height));
  z-index:9999;
  padding-top: 40px;
  padding-bottom: 40px;
}

.Title {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--tertiary);
  margin-top: 30px;
}

.Desc {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--primary);
}

.ButtonScraping {
  border-radius: 5px;
  background: var(--Monumenti-Senza-foto, #cf4130);
  display: flex;
  padding: 4px 8px;
  align-items: center;
  color: var(--colori-neutri-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 20px;
  font-family: var(--font-roboto-slab);
}

.Close {
  display: flex;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.Close:hover,
.Close:active {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.Status {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--colori-neutri-gray);
  font-family: var(--font-roboto-slab);
}


.ScrapingOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}


